import React from "react";
import { ConvertBytesToImage } from "../Utils/Utils";

function SearchListItem(props) {
    const { product } = props;
    const imageUrl = product ? ConvertBytesToImage(product?.image) : '';
    const hasMRP = product?.mrp && product.mrp > product.price;
    const discountPct = hasMRP ? Math.round((1 - product.price / product.mrp) * 100) : 0;

    const onClick = (e) => {
        e.preventDefault();
        props.onClickAddToCart(product);
    };

    return (
        <div className="product list-view">
            <a href="#" className="product-img">
                <img src={imageUrl} className="" alt={product?.name} />
            </a>
            <div className="product-info">
                <h3>
                    <a href="#">{product?.name}</a>
                </h3>
                <div className="product-value">
                    {hasMRP && (
                        <div className="d-flex align-items-center gap-2">
                            <small className="regular-price">MRP <del>₹{product.mrp}</del></small>
                            <div className="off-price">{discountPct}% off</div>
                        </div>
                    )}
                    <div className="current-price">₹{product?.price}</div>
                </div>
            </div>
            <div className="product-actions">
                <a href="#" className="btn btn-primary" onClick={onClick}>
                    <i className="ti-shopping-cart"></i>
                    Add to cart
                </a>
            </div>
        </div>
    );
}

export default SearchListItem;
